import template from './legacy-messages.html';
import './legacy-message.scss';
import bowser from 'bowser';

export default angular
  .module('doxy.unsupportedBrowserLegacyMessages', [])
  .component('unsupportedBrowserLegacyMessages', {
    template,
    bindings: {
      onHide: '&',
    },
    controller: function ($timeout, Browser) {
      this.$onInit = () => {
        let system = 'other';
        let error = null;

        if (Browser.isLegacyMobileSafari()) {
          error = 'ios-legacy';
        } else if (Browser.isUnsupportedIosBrowser()) {
          error = 'ios-non-safari';
        } else if (Browser.isSupported() && !Browser.isUpToDate()) {
          error = 'stale-browser';
        } else if (!Browser.isSupported()) {
          error = 'unsupported-browser';
        }

        if (bowser.mac) {
          system = 'mac';
        } else if (bowser.android) {
          system = 'android';
        }

        this.system = system;
        this.error = error;
        this.url = window.location.href;
        this.copied = false;
        this.onCopy = () => {
          this.copied = true;
          $timeout(() => {
            this.copied = false;
          }, 2000);
        };
      };
    },
  }).name;
